// extracted by mini-css-extract-plugin
export var linkText = "_mq-0";